import { TextField, InputAdornment } from '@mui/material';
import { ChangeEventHandler, useState } from 'react';
import { Form, Input ,InputNumber} from 'antd';

const InputFormMUI = (props: {
  value?: any,
  label?: string,
  name?: string,
  error?: string,
  taille?: number,
  type: string,
  width?: number,
  placeholder?: string,
  notRequired?: true,
  title?: string,
  maxLength?: number,
  minLength?: number,
  icon?: any,
  defaultValue?: any,
  disabled?: boolean,
  onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
  min?: number,
  max?: any,
  row?: number,
  RegExp?: RegExp,
  MessExp?: string,
  search?: true,
  onSearch?: any,
  autoFocus?: true,
  money?: boolean,
  pourcent?: boolean,
  noupercase?: true,
   textAlign?: 'left' | 'right' | 'center'
}) => {

  const {
    value,
    label,
    name,
    error,
    taille,
    type,
    placeholder,
    notRequired,
    maxLength,
    minLength,
    icon,
    defaultValue,
    disabled,
    onChange,
    min,
    max,
    row,
    autoFocus,
    money,
    pourcent,
    noupercase,
    textAlign = 'left', // 👈 par défaut à gauche
  } = props;

  // ✅ Fonction de formatage : "1234567.89" → "1 234 567,89"
  const formatNumber = (val: any) => {
    if (val === '' || val === null || isNaN(Number(val))) return '';
    return new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(Number(val));
  };
   const [displayValue, setDisplayValue] = useState<string>(
    money && props.value ? formatNumber(props.value) : props.value || ""
  );

  // ✅ Nettoyer les espaces pour récupérer le vrai nombre
  const parseNumber = (val: string) => val.replace(/\s/g, '').replace(',', '.');

  

  // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    
  //   if (onChange) {
  //     //alert("errr")
  //     if (!noupercase) {
  //       e.target.value = e.target.value.toUpperCase();
  //     }
  //     onChange(e);
  //   }
  // };

  // ✅ Gestion du changement
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    let val = e.target.value;

    // Uppercase automatique si nécessaire
    if (!noupercase) val = val.toUpperCase();

    // Si money, on retire les espaces pendant la saisie
    if (money) val = parseNumber(val);

    setDisplayValue(val);

    if (onChange) {
      // on propage la valeur brute (non formatée)
      e.target.value = val;
      onChange(e);
    }
  };

    /** 🚫 Bloquer les caractères non numériques */
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Autoriser : chiffres, flèches, tab, backspace, delete, virgule, point
    const allowedKeys = [
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Home",
      "End",
    ];

    // autoriser virgule ou point pour décimales
    if (money || type === "number" || pourcent) {
      if (
        !/[0-9.,]/.test(e.key) &&
        !allowedKeys.includes(e.key)
      ) {
        e.preventDefault();
      }
    }
  };


  // ✅ Quand on quitte le champ : formatage du nombre
  const handleBlur = () => {
    if (money) setDisplayValue(formatNumber(displayValue));
  };

  // ✅ Quand on entre dans le champ : on retire les espaces
  const handleFocus = () => {
    if (money) setDisplayValue(parseNumber(displayValue));
  };


  const inputProps: any = {
    maxLength,
    minLength,
    min,
    max,
    step: "0.01",
    autoFocus,
    disabled,
    defaultValue,
    startAdornment: icon ? <InputAdornment position="start">{icon}</InputAdornment> : null,
    style: { width: taille },
  };

  // const formatNumber = (val:any) => {
  //   if (val === '' || val === null || isNaN(val)) return '';
  //   return Number(val).toLocaleString('fr-FR'); // Format français (espace entre milliers)
  // };
  const isMultiline = type === "TextArea";
  //const inputType = type === 'number' || money || pourcent ? 'number' : 'text';
 const inputType = money || pourcent ? 'text' : type === 'number' ? 'number' : 'text';

   //const inputType = money || pourcent ? 'text' : type === 'number' ? 'number' : 'text';


  return (
  
 <Form.Item  name={props.name} style={{ marginBottom: 5 }} >
    <TextField
      fullWidth
      size='small'
      //initialValue={props.defaultValue}
      label={props.label}
      name={props.name}
      // value={props.value}
       value={displayValue}
      
      //value={props.defaultValue}
      //onChange={handleInputChange}
       //onChange={props.onChange}
      //onChange={props.onChange as ((value: any) => void) | undefined}
       onChange={handleInputChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      onKeyDown={handleKeyDown} // ✅ Bloque les caractères non numériques
      error={!!error}
      helperText={error}
     // multiline={isMultiline}
     // rows={isMultiline ? (row || 2) : undefined}
      type={inputType}
      placeholder={placeholder}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        ...inputProps,
        endAdornment: pourcent ? <InputAdornment position="end">%</InputAdornment> : null,
        inputProps: {
          min,
          max,
          maxLength,
          step: "0.01",
        }
      }}
      variant="outlined"
       sx={{
          width: '100%',
          borderRadius: 2,
          '& .MuiInputBase-input': {
            textAlign: textAlign, // ✅ Dynamique
          },
          '& .MuiInputLabel-root': {
            fontWeight: 'bold',
            fontSize: '18px',
          },
        }}
      // sx={{ 
      //   width: '100%', borderRadius:10,
      //   '& .MuiInputLabel-root': {
      //    fontWeight: 'bold',
      //   fontSize: '18px',
      //   }
        
      //  }}
    />
 </Form.Item>
    
  );
};

export default InputFormMUI;
